"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextureLoaderNDArray = require("./TextureLoaderNDArray");

var _TextureLoaderNDArray2 = _interopRequireDefault(_TextureLoaderNDArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loaderClasses = [_TextureLoaderNDArray2.default];

/**
 * Extensible way to support more sampler2D uniform texture formats.
 * You must call the methods statically before the `<Surface>` is instanciated.
 * @namespace
 */
var TextureLoaders = {
  /**
   * Add a TextureLoader class to extend texture format support.
   * @memberof TextureLoaders
   */
  add: function add(loader) {
    loaderClasses.push(loader);
  },

  /**
   * Remove a previously added TextureLoader class.
   * @memberof TextureLoaders
   */
  remove: function remove(loader) {
    var i = loaderClasses.indexOf(loader);
    if (i !== -1) loaderClasses.splice(i, 1);
  },
  get: function get() {
    return loaderClasses;
  }
};

exports.default = TextureLoaders;
//# sourceMappingURL=TextureLoaders.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react/lib/TextureLoaders.js
// module id = 82
// module chunks = 0